// @flow

import React, { useState } from "react"
import { withRouter } from "react-router-dom"
import { useIntl } from "react-intl"
import { get } from "lodash"
import { Icon, Form, Input, Tooltip, Button, Alert } from "antd"
import styled from "styled-components"
import cabonlineLogo from "../../../shared/resources/cabonline_gray.svg"
import loadingCheckmark from "../../../shared/resources/loading-checkmark.svg"
import { ParagraphPrimary, TitlePrimary } from "../../../shared/components/text"
import DriverWebStore from "../../../shared/stores/DriverWebStore"
import { gutter } from "shared/utils/design"

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${gutter * 2}px;
  background: ${p => (p.black ? "black" : "white")};
  ${p => p.center && "justify-content: center"};
  height: 100%;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 340px;
`

const SuccessWrapper = styled.div`
  text-align: center;
`

const InputWrapper = styled.div`
  margin-top: ${gutter}px;
  max-width: ${p => p.width}px;
`

const ErrorAlert = styled(Alert)`
  margin: 12px 0;
`

const PhoneNumberVerification = ({ match, form }) => {
  const Intl = useIntl()
  const [isVerified, setIsVerified] = useState(false)
  const [error, setError] = useState(null)
  const { token } = match ? match.params : {}
  const { getFieldDecorator } = form

  const handleFormSubmit = e => {
    e.preventDefault()
    form.validateFields((err, values) => {
      if (!err) {
        verifyPhoneNumber(values)
      }
    })
  }

  const verifyPhoneNumber = async ({ tfl }) => {
    try {
      setError(null)
      await DriverWebStore.verifyPhoneNumber(token, tfl)
      setIsVerified(true)
    } catch (e) {
      if (e.response && e.response.data && e.response.data.errors[0]) {
        const attemptsLeft = get(
          e,
          "response.data.errors[0].params.remainingAttempts",
          0
        )

        if (attemptsLeft) {
          setError(
            Intl.formatMessage(
              { id: "apps.driver-web.onboarding.error.wrongTfl.attemptsLeft" },
              { attemptsLeft }
            )
          )
        } else {
          setError(
            Intl.formatMessage({
              id: "apps.driver-web.phonenumberverification.token.expired"
            })
          )
        }
      }
    }
  }

  const renderForm = () => (
    <>
      <TitlePrimary>
        {Intl.formatMessage({
          id: "apps.driver-web.phonenumberverification.title"
        })}
      </TitlePrimary>
      <ParagraphPrimary>
        {Intl.formatMessage({
          id: "apps.driver-web.phonenumberverification.content"
        })}
      </ParagraphPrimary>
      <Form onSubmit={handleFormSubmit}>
        <InputWrapper width={140}>
          <Form.Item
            label={
              <span>
                {Intl.formatMessage({
                  id: "apps.driver-web.onboarding.tfl.label"
                })}
                &nbsp;
                <Tooltip
                  title={Intl.formatMessage({
                    id: "apps.driver-web.onboarding.tfl.tooltip"
                  })}
                >
                  <Icon type="question-circle-o" />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator("tfl", {
              rules: [
                {
                  required: true,
                  message: Intl.formatMessage({
                    id: "common.required"
                  })
                },
                {
                  whitespace: true,
                  message: Intl.formatMessage({ id: "common.required" })
                }
              ]
            })(
              <Input placeholder={Intl.formatMessage({ id: "common.TFL" })} />
            )}
          </Form.Item>
        </InputWrapper>
        {error && <ErrorAlert description={error} type="error" />}
        <Button type={"primary"} htmlType={"submit"}>
          {Intl.formatMessage({ id: "common.save" })}
        </Button>
      </Form>
    </>
  )

  const renderSuccess = () => (
    <SuccessWrapper>
      <img
        src={loadingCheckmark}
        style={{ fontSize: 120, marginBottom: 16 }}
        alt="Loader"
      />
      <TitlePrimary bold={false} white>
        {Intl.formatMessage({ id: "driverWeb.phoneNumberVerifiedLabel" })}
      </TitlePrimary>
    </SuccessWrapper>
  )

  return (
    <Container black={isVerified} center={isVerified}>
      <ContentWrapper>
        {isVerified ? renderSuccess() : renderForm()}
      </ContentWrapper>
      <LogoWrapper>
        <img src={cabonlineLogo} style={{ width: 200 }} alt="logo" />
      </LogoWrapper>
    </Container>
  )
}

export default (Form.create()(withRouter(PhoneNumberVerification)): any)
